import React from 'react';
import _ from 'lodash';

import { DateInput } from '../../DateInput';
import { WorkerInputText } from '../WorkerInputText';
import Style from '../../../styles/componentStyle/worker/medicalExamination/medicalExamination.scss';

import {
  FormElement,
  FormList,
  FormListItem,
  FormListItemChild,
  FormListItemGroup,
  FormListSubHeader,
} from '../../CommonFormComponents';
import { CcusLineComponent, CcusTitleBlock } from '../../CcusFormComponent';
import {
  OBSERVATION_EXISTANCE_FLAG,
  ASSIGNED_DUE_TO_ILLNESS_FLAG,
  FREQUENCY_LIST,
  MEDICAL_EXAMINATION_PERIOD_KIND,
  FREQUENCY_HELP_TEXT,
  CCUS_SPECIAL_MEDICAL_EXAMINATION,
} from '../../../utilities/constants';
import { RadioButtonIcon } from '../../icons/RadioButtonIcon';
import {
  getTextAssignedDueToIllnessFlag,
  getTextObservationExistanceExclusionFlag,
} from '../../../utilities/constantsUtil';
import { Description } from '../../Description';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import { QuestionIcon } from '../../icons/QuestionIcon';
import ComboBox from '../../combobox/ComboBox';
import { validMedicalExpirationDate } from '../../../utilities/dateSelectorUtility';
import { isNullOrUndefinedOrEmptyStr } from '../../../utilities/stringUtil';
import Tippy from '../../ReactTippy';
import { messageUtility } from '../../../utilities/messageUtility';

/**
 * 作業員編集 画面 > 健康診断
 */
const MedicalExaminationForm = ({
  events,
  formValues,
  ccus_info,
  messages,
  disabledAll,
  ccusDescription,
}) => {
  let hasValueCCUSbtn = false;
  _.forEach(ccus_info, item => {
    if (!_.isEmpty(item)) {
      hasValueCCUSbtn = true;
      return false;
    }
  });

  const TitleElementWithCcus = ({ title, noMarginTop }) => (
    <FormListSubHeader
      title={title}
      ccusComponent={
        disabledAll || !hasValueCCUSbtn ? null : (
          <CcusTitleBlock
            disabled={disabledAll}
            onClick={e => {
              e.preventDefault();
              events.showCcusInfoTranscriptionAgreementDialog();
            }}
          />
        )
      }
      noMarginTop={noMarginTop}
    />
  );

  const TitleElement = ({ title }) => <FormListSubHeader title={title} />;

  const ccusElement = key => {
    const val = ccus_info[key];
    if (!val || disabledAll) {
      return null;
    }
    return (
      <CcusLineComponent
        onClick={() => {
          events.setCCUSValuesHealth(key);
        }}
      >
        {val}
      </CcusLineComponent>
    );
  };

  const workerInputTextOnChange = e => {
    events.setValueMedicalExamination(e.target.name, e.target.value);
  };

  const workerInputTextOnBlur = e => {
    events.validate(e.target.name);
  };

  const medicalExaminationDateOnBlur = () => {
    events.validate('medical_examination_date');
  };

  return (
    <div
      className={`${Style.medicalExaminationForm} contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix`}
    >
      {ccusDescription}
      <FormList>
        <TitleElementWithCcus title='健康診断' noMarginTop={true} />
        <FormListItem label='受診日' safetyDocItem={true}>
          {disabledAll && !formValues.medical_examination_date ? null : (
            <DateInput
              dateString={formValues.medical_examination_date}
              disabled={disabledAll}
              onChangeValue={val => {
                events.setValueMedicalExamination(
                  'medical_examination_date',
                  val
                );
              }}
              onBlur={medicalExaminationDateOnBlur}
              isPreview={disabledAll}
              ccusComponent={ccusElement('medical_examination_date')}
              warning={searchWarningMessage(
                formValues.medical_examination_date,
                MEDICAL_EXAMINATION_PERIOD_KIND.DEFAULT,
                messages.medical_examination_date_error
              )}
              message={messages.medical_examination_date_error}
              jpDelimiterChar={true}
            />
          )}
        </FormListItem>

        <FormListItem label='受診病院'>
          <FormElement validate={messages.hospital_name}>
            <WorkerInputText
              name='hospital_name'
              value={formValues.hospital_name}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='所見'>
          <FormElement validate={messages.observation}>
            <WorkerInputText
              name='observation'
              value={formValues.observation ? formValues.observation : ''}
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='視力'>
          <FormElement
            validate={
              messages.visual_acuity_left || messages.visual_acuity_right
            }
          >
            <React.Fragment>
              <label htmlFor='eyesight'>
                <div className={Style.eyesight__left}>
                  <span className={Style.inputShort}>
                    左
                    <input
                      type='text'
                      name='visual_acuity_left'
                      placeholder='2.0'
                      value={
                        formValues.visual_acuity_left
                          ? formValues.visual_acuity_left
                          : ''
                      }
                      disabled={disabledAll}
                      maxLength={4}
                      onChange={e => {
                        events.setValueMedicalExamination(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      onBlur={workerInputTextOnBlur}
                      className='form-list__input-short'
                    />
                  </span>
                </div>
                <div>
                  <span className={Style.inputShort}>
                    右
                    <input
                      type='text'
                      name='visual_acuity_right'
                      placeholder='2.0'
                      value={
                        formValues.visual_acuity_right
                          ? formValues.visual_acuity_right
                          : ''
                      }
                      disabled={disabledAll}
                      maxLength={4}
                      onChange={e => {
                        events.setValueMedicalExamination(
                          e.target.name,
                          e.target.value
                        );
                      }}
                      onBlur={workerInputTextOnBlur}
                      className='form-list__input-short'
                    />
                  </span>
                </div>
              </label>
            </React.Fragment>
          </FormElement>
        </FormListItem>

        <FormListItem label='血圧' safetyDocItem={true}>
          <FormElement validate={messages.high_bp || messages.low_bp}>
            <label htmlFor='blood_pressure'>
              <div className={Style.blood_pressure__left}>
                <span className={Style.inputShort}>
                  上
                  <input
                    type='text'
                    name='high_bp'
                    placeholder='125'
                    value={formValues.high_bp ? formValues.high_bp : ''}
                    disabled={disabledAll}
                    maxLength={4}
                    onChange={e => {
                      events.setValueMedicalExamination(
                        e.target.name,
                        e.target.value
                      );
                    }}
                    onBlur={workerInputTextOnBlur}
                    className='form-list__input-short'
                  />
                </span>
              </div>
              <div>
                <span className={Style.inputShort}>
                  下
                  <input
                    type='text'
                    name='low_bp'
                    placeholder='75'
                    value={formValues.low_bp ? formValues.low_bp : ''}
                    disabled={disabledAll}
                    maxLength={4}
                    onChange={e => {
                      events.setValueMedicalExamination(
                        e.target.name,
                        e.target.value
                      );
                    }}
                    onBlur={workerInputTextOnBlur}
                    className='form-list__input-short'
                  />
                </span>
              </div>
            </label>
          </FormElement>
        </FormListItem>

        <FormListItem label='X線所見'>
          <FormElement validate={messages.x_ray_observation}>
            <WorkerInputText
              name='x_ray_observation'
              value={
                formValues.x_ray_observation ? formValues.x_ray_observation : ''
              }
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='糖検査'>
          <FormElement validate={messages.sugar_inspection}>
            <WorkerInputText
              name='sugar_inspection'
              value={
                formValues.sugar_inspection ? formValues.sugar_inspection : ''
              }
              messages={messages}
              disabled={disabledAll}
              maxLength={255}
              onChange={workerInputTextOnChange}
              onBlur={workerInputTextOnBlur}
            />
          </FormElement>
        </FormListItem>

        <FormListItem label='疾病による適正配置対象者'>
          <FormElement>
            {disabledAll ? (
              <span>
                {getTextAssignedDueToIllnessFlag(
                  formValues.assigned_due_to_illness_flag
                )}
              </span>
            ) : (
              <React.Fragment>
                {_.map(ASSIGNED_DUE_TO_ILLNESS_FLAG, item => {
                  return (
                    <div
                      key={`ASSIGNED_DUE_TO_ILLNESS_FLAG${item.ID}`}
                      className='form-list-radio__item'
                    >
                      <label className='radio'>
                        <input
                          type='radio'
                          checked={
                            formValues.assigned_due_to_illness_flag === item.ID
                          }
                          value={item.ID}
                          onChange={() => {
                            events.setValueMedicalExamination(
                              'assigned_due_to_illness_flag',
                              item.ID
                            );
                          }}
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{item.TEXT}</span>
                      </label>
                    </div>
                  );
                })}
              </React.Fragment>
            )}
          </FormElement>
        </FormListItem>

        <TitleElement title='特殊健康診断' />
        {!disabledAll && (
          <div className='form-list-default__ExceptionalItems'>
            <Description type='primary'>
              <React.Fragment>
                特殊健康診断の対象となる有害な業務および、業務で取扱う物質が、どの特殊健康診断に対応するのかにつきましては、最寄りの都道府県労働局又は労働基準監督署までお問い合わせください。
              </React.Fragment>
            </Description>
          </div>
        )}
        {/* 特殊健康診断 */}
        <SpecialExamination formValues={formValues} messages={messages} />

        {/* じん肺健康診断 */}
        <Pneumoconiosis
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          events={events}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 石綿健康診断 */}
        <Asbestos
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 有機溶剤健康診断 */}
        <OrganicSolvent
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 特定化学物質健康診断 */}
        <SpecificChemicals
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 電離放射線健康診断 */}
        <Ionization
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 振動健康診断 */}
        <VibrationDisease
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
        />

        {/* ⾼気圧業務健康診断 */}
        <HighPressure
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 鉛健康診断 */}
        <Lead
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 四アルキル鉛健康診断 */}
        <TetraalkylLead
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* 除染等電離放射線健康診断 */}
        <Decontamination
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          ccusInfo={ccus_info}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
          copyCcusValueFn={events.setCCUSValuesHealth}
        />

        {/* ⻭科特殊健診（歯牙酸蝕症健診） */}
        <Dental
          formValues={formValues}
          messages={messages}
          disabled={disabledAll}
          onChangeFn={events.setValueMedicalExamination}
          onBlurFn={events.validate}
          switchDisplay={events.switchDisplay}
        />
      </FormList>
    </div>
  );
};
export default MedicalExaminationForm;

/**
 * CCUS情報転記のためのコンポーネントを作成する
 * TODO 同様のメソッドにccusElementがあるが最終的にccusElementは削除予定
 */
const ccusForm = (ccusInfo, key, disabled, copyCcusValueFn) => {
  const val = !_.isNil(ccusInfo) ? ccusInfo[key] : null;
  if (!val || disabled) {
    return null;
  }
  return (
    <CcusLineComponent
      onClick={() => {
        copyCcusValueFn(key);
      }}
    >
      受診あり（{val}）
    </CcusLineComponent>
  );
};

/**
 * 特殊健康診断の廃止警告文コンポーネント取得
 * @returns 廃止警告文コンポーネント
 */
const Warning = () => {
  return (
    <FormElement>
      <Description type='primary'>
        <React.Fragment>
          <div className='bold'>ご注意</div>
          2021年10月末より、この項目への入力および労務安全書類への出力を停止させて頂きました。
          <br />
          登録情報の移行が未完了の場合は、早期に下記の各特殊健康診断欄への登録をお願い致します。
          <br />
          すでに提出いただいている作業員名簿に関しては、再提出不要です。
        </React.Fragment>
      </Description>
    </FormElement>
  );
};

/**
 * 警告メッセージが存在するか検索する
 * @param {string} date: 受診日
 * @param {Object} obj: 期限切れチェックオブジェクト
 * @param {string} errorMessage: エラーメッセージ
 * @return {string|null} message: 警告メッセージ
 */
const searchWarningMessage = (date, obj, errorMessage) => {
  if (isNullOrUndefinedOrEmptyStr(errorMessage) === true) {
    return validMedicalExpirationDate(date, obj);
  }

  return null;
};

/**
 * 警告メッセージが存在するか検索する
 * @param {string} date: 受診日
 * @param {string} errorMessage: エラーメッセージ
 * @param {string} targetName: 期限切れチェックオブジェクト
 * @param {string} frequencyOfMedicalVisits: 受診頻度
 * @param {boolean} isPreview
 * @return {string|null} message: 警告メッセージ
 */
const wrapperSearchWarningMessage = (
  date,
  errorMessage,
  targetName,
  frequencyOfMedicalVisits,
  isPreview
) => {
  if (isNullOrUndefinedOrEmptyStr(errorMessage) === false) {
    return null;
  }

  let tempObject;
  if (isNullOrUndefinedOrEmptyStr(frequencyOfMedicalVisits)) {
    tempObject = FREQUENCY_LIST[targetName][0];
  } else {
    tempObject = _.find(FREQUENCY_LIST[targetName], {
      value: frequencyOfMedicalVisits,
    });
  }

  const messageValidate = validMedicalExpirationDate(date, tempObject);
  if (isPreview) {
    return messageValidate;
  }
  return (
    messageValidate && (
      <React.Fragment>
        {messageValidate}
        <br />
        {messageUtility.getMessage('W-000-019')}
      </React.Fragment>
    )
  );
};

/**
 * 表示/非表示切り替えチェックボックスコンポーネント
 */
const DisplaySwitch = ({ disabled, checked, targetName, onChangeFn }) => {
  if (disabled) {
    return null;
  }
  return (
    <FormElement>
      <label className='checkbox'>
        <input
          name={targetName}
          type='checkbox'
          disabled={disabled}
          checked={checked}
          onChange={onChangeFn}
        />
        <i className='i-square i-3x' />
        受診あり
      </label>
    </FormElement>
  );
};

/**
 * 受診日
 */
const ExaminationDate = ({
  formValues,
  messages,
  disabled,
  targetName,
  onChangeFn,
  onBlurFn,
  safetyDocItem = false,
  info,
  warning,
}) => {
  return (
    <FormListItemChild label='受診日' safetyDocItem={safetyDocItem}>
      {disabled && !formValues[targetName] ? null : (
        <DateInput
          dateString={formValues[targetName]}
          disabled={disabled}
          isPreview={disabled}
          message={messages[targetName]}
          warning={warning}
          jpDelimiterChar={true}
          onChangeValue={val => onChangeFn(targetName, val)}
          onBlur={() => onBlurFn(targetName)}
          info={info}
        />
      )}
    </FormListItemChild>
  );
};

/**
 * 受診頻度
 */
const MedicalExaminationFrequency = ({
  value,
  targetName,
  disabled,
  onChangeFn,
}) => {
  let label = '受診頻度';
  if (!disabled) {
    const helpText = _.get(FREQUENCY_HELP_TEXT, targetName);
    label = (
      <React.Fragment>
        受診頻度{' '}
        <Tippy
          duration={10}
          distance={24}
          arrow={true}
          arrowType='sharp'
          delay={[500, 0]}
          placement='bottom'
          followCursor={true}
          html={renderTooltipContent(helpText)}
        >
          <QuestionIcon className='icon--2x question-icon' />
        </Tippy>
      </React.Fragment>
    );
  }
  return (
    <FormListItemChild label={label}>
      <FormElement>
        {disabled ? (
          <span>{value}</span>
        ) : (
          <React.Fragment>
            <select
              name={targetName}
              value={value}
              onChange={e => {
                onChangeFn(targetName, e.target.value);
              }}
            >
              {_.map(FREQUENCY_LIST[targetName], (item, index) => {
                return (
                  // 受診頻度はテキストで保存するためidではなくvalueを設定している
                  <option key={`${targetName}_${index}`} value={item.value}>
                    {item.value}
                  </option>
                );
              })}
            </select>
            <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
          </React.Fragment>
        )}
      </FormElement>
    </FormListItemChild>
  );
};

/**
 * 所見の有無
 */
const ObservationExistance = ({
  formValues,
  disabled,
  targetName,
  onChangeFn,
}) => {
  return (
    <FormListItemChild label='所見の有無'>
      <FormElement>
        {disabled ? (
          <span>
            {getTextObservationExistanceExclusionFlag(formValues[targetName])}
          </span>
        ) : (
          <React.Fragment>
            {_.map(OBSERVATION_EXISTANCE_FLAG, item => {
              return (
                <div
                  key={`${targetName}_div_${item.ID}`}
                  className='form-list-radio__item'
                >
                  <label className='radio'>
                    <input
                      type='radio'
                      checked={formValues[targetName] === item.ID}
                      value={item.ID}
                      onChange={() => {
                        onChangeFn(targetName, item.ID);
                      }}
                    />
                    <RadioButtonIcon className='icon--2x' />
                    <span>{item.TEXT}</span>
                  </label>
                </div>
              );
            })}
          </React.Fragment>
        )}
      </FormElement>
    </FormListItemChild>
  );
};

/**
 * 視力
 */
const VisualAcuity = ({
  formValues,
  messages,
  disabled,
  leftTargetName,
  rightTargetName,
  onChangeFn,
  onBlurFn,
  placeholder,
}) => {
  return (
    <FormListItemChild label='視力'>
      <FormElement
        validate={messages[leftTargetName] || messages[rightTargetName]}
      >
        <React.Fragment>
          <label htmlFor='eyesight'>
            <div className={Style.eyesight__left}>
              <span className={Style.inputShort}>
                左
                <input
                  type='text'
                  name={leftTargetName}
                  placeholder={placeholder ? placeholder : '2.0'}
                  value={
                    formValues[leftTargetName] ? formValues[leftTargetName] : ''
                  }
                  disabled={disabled}
                  maxLength={4}
                  onChange={e => {
                    onChangeFn(leftTargetName, e.target.value);
                  }}
                  onBlur={() => {
                    onBlurFn(leftTargetName);
                  }}
                  className='form-list__input-short'
                />
              </span>
            </div>
            <div>
              <span className={Style.inputShort}>
                右
                <input
                  type='text'
                  name={rightTargetName}
                  placeholder={placeholder ? placeholder : '2.0'}
                  value={
                    formValues[rightTargetName]
                      ? formValues[rightTargetName]
                      : ''
                  }
                  disabled={disabled}
                  maxLength={4}
                  onChange={e => {
                    onChangeFn(rightTargetName, e.target.value);
                  }}
                  onBlur={() => {
                    onBlurFn(rightTargetName);
                  }}
                  className='form-list__input-short'
                />
              </span>
            </div>
          </label>
        </React.Fragment>
      </FormElement>
    </FormListItemChild>
  );
};

/**
 * 血圧
 */
const BloodPressure = ({
  formValues,
  messages,
  disabled,
  highTargetName,
  lowTargetName,
  onChangeFn,
  onBlurFn,
  placeholderHigh,
  placeholderLow,
}) => {
  return (
    <FormListItemChild label='血圧'>
      <FormElement
        validate={messages[highTargetName] || messages[lowTargetName]}
      >
        <label htmlFor='blood_pressure'>
          <div className={Style.blood_pressure__left}>
            <span className={Style.inputShort}>
              上
              <input
                type='text'
                name={highTargetName}
                placeholder={placeholderHigh ? placeholderHigh : '125'}
                value={
                  formValues[highTargetName] ? formValues[highTargetName] : ''
                }
                disabled={disabled}
                maxLength={4}
                onChange={e => {
                  onChangeFn(highTargetName, e.target.value);
                }}
                onBlur={() => {
                  onBlurFn(highTargetName);
                }}
                className='form-list__input-short'
              />
            </span>
          </div>
          <div>
            <span className={Style.inputShort}>
              下
              <input
                type='text'
                name='low_bp'
                placeholder={placeholderLow ? placeholderLow : '75'}
                value={
                  formValues[lowTargetName] ? formValues[lowTargetName] : ''
                }
                disabled={disabled}
                maxLength={4}
                onChange={e => {
                  onChangeFn(lowTargetName, e.target.value);
                }}
                onBlur={() => {
                  onBlurFn(lowTargetName);
                }}
                className='form-list__input-short'
              />
            </span>
          </div>
        </label>
      </FormElement>
    </FormListItemChild>
  );
};

/**
 * 汎用テキスト入力フォーム
 * 特殊健康診断名, 受診病院, X線所見, 糖検査に利用
 */
const GeneralTextInput = ({
  labelName,
  formValues,
  messages,
  disabled,
  targetName,
  maxLength,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  copyCcusValueFn,
  safetyDocItem,
}) => {
  return (
    <FormListItemChild label={labelName} safetyDocItem={safetyDocItem}>
      <FormElement
        ccusComponent={ccusForm(
          ccusInfo,
          targetName,
          disabled,
          copyCcusValueFn
        )}
        validate={messages[targetName]}
      >
        <WorkerInputText
          name={targetName}
          value={formValues[targetName] ? formValues[targetName] : ''}
          messages={messages}
          disabled={disabled}
          maxLength={maxLength}
          onChange={e => onChangeFn(targetName, e.target.value)}
          onBlur={() => {
            onBlurFn(targetName);
          }}
        />
      </FormElement>
    </FormListItemChild>
  );
};
GeneralTextInput.defaultProps = {
  maxLength: 255,
  // CCUS転記情報がないものはccusInfoとcopyCcusValueFnを設定しないためデフォルト値を設定
  ccusInfo: {},
  copyCcusValueFn: {},
};

/**
 * 特殊健康診断
 */
const SpecialExamination = ({ formValues, messages }) => {
  return (
    <FormListItemGroup label='特殊健康診断' rightComponent={<Warning />}>
      {/* 特殊健康診断名 */}
      <GeneralTextInput
        labelName='特殊健康診断名'
        formValues={formValues}
        messages={messages}
        disabled={true}
        targetName='special_medical_examination_name'
      />
      {/* 受診日 */}
      <ExaminationDate
        formValues={formValues}
        messages={messages}
        disabled={true}
        targetName='special_medical_examination_date'
        warning={searchWarningMessage(
          formValues.special_medical_examination_date,
          MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
          messages.special_medical_examination_date
        )}
      />
    </FormListItemGroup>
  );
};

/**
 * じん肺健康診断
 */
const Pneumoconiosis = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  // じん肺管理区分リスト
  const pneumoconiosisClassList = [
    { id: 1, name: '管理1' },
    { id: 1, name: '管理2' },
    { id: 1, name: '管理3（イ）' },
    { id: 1, name: '管理3（ロ）' },
    { id: 1, name: '管理4' },
  ];

  return (
    <FormListItemGroup
      label='じん肺健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showPneumoconiosis}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_PNEUMOCONIOSIS.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_PNEUMOCONIOSIS.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showPneumoconiosis && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_PNEUMOCONIOSIS.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={!disabled && '最新のじん肺健康診断受診⽇を⼊⼒してください。'}
            warning={wrapperSearchWarningMessage(
              formValues.special_medical_examination_date_pneumoconiosis,
              messages.special_medical_examination_date_pneumoconiosis,
              'pneumoconiosis_medical_examination_frequency',
              formValues.pneumoconiosis_medical_examination_frequency,
              disabled
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='pneumoconiosis_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='pneumoconiosis_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* じん肺管理区分 じん肺のみの項目のため他項目と異なりコンポーネント化はしない */}
          <FormListItemChild label='じん肺管理区分'>
            <FormElement>
              <ComboBox
                listId={`prefecture-list`}
                disabled={disabled}
                value={
                  formValues.pneumoconiosis_class === null
                    ? ''
                    : formValues.pneumoconiosis_class
                }
                comboBoxValueKey='name'
                comboBoxList={pneumoconiosisClassList}
                onChange={e => {
                  onChangeFn('pneumoconiosis_class', e.target.value);
                }}
                maxLength={20}
              />
            </FormElement>
          </FormListItemChild>
          {/* 受診頻度 */}
          <MedicalExaminationFrequency
            value={formValues.pneumoconiosis_medical_examination_frequency}
            targetName='pneumoconiosis_medical_examination_frequency'
            disabled={disabled}
            onChangeFn={onChangeFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='pneumoconiosis_visual_acuity_left'
            rightTargetName='pneumoconiosis_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='pneumoconiosis_high_bp'
            lowTargetName='pneumoconiosis_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='pneumoconiosis_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='pneumoconiosis_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 石綿健康診断
 */
const Asbestos = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='石綿健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showAsbestos}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_ASBESTOS.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_ASBESTOS.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showAsbestos && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_ASBESTOS.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={!disabled && '最新の石綿健康診断受診⽇を⼊⼒してください。'}
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_asbestos,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_asbestos
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='asbestos_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='asbestos_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='asbestos_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='asbestos_visual_acuity_left'
            rightTargetName='asbestos_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='asbestos_high_bp'
            lowTargetName='asbestos_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='asbestos_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='asbestos_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 有機溶剤健康診断
 */
const OrganicSolvent = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='有機溶剤健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showOrganicSolvent}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_ORGANIC_SOLVENT.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_ORGANIC_SOLVENT.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showOrganicSolvent && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_ORGANIC_SOLVENT.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled && '最新の有機溶剤健康診断受診⽇を⼊⼒してください。'
            }
            warning={wrapperSearchWarningMessage(
              formValues.special_medical_examination_date_organic_solvent,
              messages.special_medical_examination_date_organic_solvent,
              'organic_solvent_medical_examination_frequency',
              formValues.organic_solvent_medical_examination_frequency,
              disabled
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='organic_solvent_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='organic_solvent_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='organic_solvent_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 受診頻度 */}
          <MedicalExaminationFrequency
            value={formValues.organic_solvent_medical_examination_frequency}
            targetName='organic_solvent_medical_examination_frequency'
            disabled={disabled}
            onChangeFn={onChangeFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='organic_solvent_visual_acuity_left'
            rightTargetName='organic_solvent_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='organic_solvent_high_bp'
            lowTargetName='organic_solvent_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='organic_solvent_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='organic_solvent_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 特定化学物質健康診断
 */
const SpecificChemicals = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='特定化学物質健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showSpecificChemicals}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_SPECIFIC_CHEMICALS.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_SPECIFIC_CHEMICALS.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showSpecificChemicals && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_SPECIFIC_CHEMICALS.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled &&
              '最新の特定化学物質健康診断受診⽇を⼊⼒してください。'
            }
            warning={wrapperSearchWarningMessage(
              formValues.special_medical_examination_date_specific_chemicals,
              messages.special_medical_examination_date_specific_chemicals,
              'specific_chemicals_medical_examination_frequency',
              formValues.specific_chemicals_medical_examination_frequency,
              disabled
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='specific_chemicals_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='specific_chemicals_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='specific_chemicals_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 受診頻度 */}
          <MedicalExaminationFrequency
            value={formValues.specific_chemicals_medical_examination_frequency}
            targetName='specific_chemicals_medical_examination_frequency'
            disabled={disabled}
            onChangeFn={onChangeFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='specific_chemicals_visual_acuity_left'
            rightTargetName='specific_chemicals_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='specific_chemicals_high_bp'
            lowTargetName='specific_chemicals_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='specific_chemicals_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='specific_chemicals_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 電離放射線健康診断
 */
const Ionization = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='電離放射線健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showIonization}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_IONIZATION.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_IONIZATION.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showIonization && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_IONIZATION.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled && '最新の電離放射線健康診断受診⽇を⼊⼒してください。'
            }
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_ionization,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_ionization
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='ionization_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='ionization_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='ionization_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='ionization_visual_acuity_left'
            rightTargetName='ionization_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='ionization_high_bp'
            lowTargetName='ionization_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='ionization_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='ionization_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 振動病健康診断
 */
const VibrationDisease = ({
  formValues,
  messages,
  disabled,
  onChangeFn,
  onBlurFn,
  switchDisplay,
}) => {
  return (
    <FormListItemGroup
      label='振動健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showVibrationDisease}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_VIBRATION_DISEASE.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
        </React.Fragment>
      }
    >
      {formValues.showVibrationDisease && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_VIBRATION_DISEASE.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={!disabled && '最新の振動健康診断受診⽇を⼊⼒してください。'}
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_vibration_disease,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_vibration_disease
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='vibration_disease_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='vibration_disease_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='vibration_disease_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='vibration_disease_visual_acuity_left'
            rightTargetName='vibration_disease_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='vibration_disease_high_bp'
            lowTargetName='vibration_disease_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='vibration_disease_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='vibration_disease_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * ⾼気圧業務健康診断
 */
const HighPressure = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='⾼気圧業務健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showHighPressure}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_HIGH_PRESSURE.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_HIGH_PRESSURE.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showHighPressure && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_HIGH_PRESSURE.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled && '最新の⾼気圧業務健康診断受診⽇を⼊⼒してください。'
            }
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_high_pressure,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_high_pressure
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='high_pressure_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='high_pressure_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='high_pressure_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='high_pressure_visual_acuity_left'
            rightTargetName='high_pressure_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='high_pressure_high_bp'
            lowTargetName='high_pressure_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='high_pressure_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='high_pressure_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 鉛健康診断
 */
const Lead = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='鉛健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showLead}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_LEAD.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_LEAD.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showLead && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_LEAD.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={!disabled && '最新の鉛健康診断受診⽇を⼊⼒してください。'}
            warning={wrapperSearchWarningMessage(
              formValues.special_medical_examination_date_lead,
              messages.special_medical_examination_date_lead,
              'lead_medical_examination_frequency',
              formValues.lead_medical_examination_frequency,
              disabled
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='lead_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='lead_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='lead_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 受診頻度 */}
          <MedicalExaminationFrequency
            value={formValues.lead_medical_examination_frequency}
            targetName='lead_medical_examination_frequency'
            disabled={disabled}
            onChangeFn={onChangeFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='lead_visual_acuity_left'
            rightTargetName='lead_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='lead_high_bp'
            lowTargetName='lead_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='lead_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='lead_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 四アルキル鉛健康診断
 */
const TetraalkylLead = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='四アルキル鉛健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showTetraalkylLead}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_TETRAALKYL_LEAD.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_TETRAALKYL_LEAD.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showTetraalkylLead && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_TETRAALKYL_LEAD.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled &&
              '最新の四アルキル鉛健康診断受診⽇を⼊⼒してください。'
            }
            warning={wrapperSearchWarningMessage(
              formValues.special_medical_examination_date_tetraalkyl_lead,
              messages.special_medical_examination_date_tetraalkyl_lead,
              'tetraalkyl_lead_medical_examination_frequency',
              formValues.tetraalkyl_lead_medical_examination_frequency,
              disabled
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='tetraalkyl_lead_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='tetraalkyl_lead_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='tetraalkyl_lead_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 受診頻度 */}
          <MedicalExaminationFrequency
            value={formValues.tetraalkyl_lead_medical_examination_frequency}
            targetName='tetraalkyl_lead_medical_examination_frequency'
            disabled={disabled}
            onChangeFn={onChangeFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='tetraalkyl_lead_visual_acuity_left'
            rightTargetName='tetraalkyl_lead_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='tetraalkyl_lead_high_bp'
            lowTargetName='tetraalkyl_lead_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='tetraalkyl_lead_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='tetraalkyl_lead_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * 除染等電離放射線健康診断
 */
const Decontamination = ({
  formValues,
  messages,
  disabled,
  ccusInfo,
  onChangeFn,
  onBlurFn,
  switchDisplay,
  copyCcusValueFn,
}) => {
  return (
    <FormListItemGroup
      label='除染等電離放射線健康診断'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showDecontamination}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_DECONTAMINATION.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
          {ccusForm(
            ccusInfo,
            CCUS_SPECIAL_MEDICAL_EXAMINATION
              .SPECIAL_MEDICAL_EXAMINATION_DATE_DECONTAMINATION.CCUS_NAME,
            disabled,
            copyCcusValueFn
          )}
        </React.Fragment>
      }
    >
      {formValues.showDecontamination && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_DECONTAMINATION.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled &&
              '最新の除染等電離放射線健康診断受診⽇を⼊⼒してください。'
            }
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_decontamination,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_decontamination
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='decontamination_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='decontamination_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='decontamination_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='decontamination_visual_acuity_left'
            rightTargetName='decontamination_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='decontamination_high_bp'
            lowTargetName='decontamination_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='decontamination_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='decontamination_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

/**
 * ⻭科特殊健診（歯牙酸蝕症健診）
 */
const Dental = ({
  formValues,
  messages,
  disabled,
  onChangeFn,
  onBlurFn,
  switchDisplay,
}) => {
  return (
    <FormListItemGroup
      label='⻭科特殊健診（歯牙酸蝕症健診）'
      rightComponent={
        <React.Fragment>
          <DisplaySwitch
            disabled={disabled}
            checked={formValues.showDental}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_DENTAL.TARGET_NAME
            }
            onChangeFn={switchDisplay}
          />
        </React.Fragment>
      }
    >
      {formValues.showDental && (
        <React.Fragment>
          {/* 受診日 */}
          <ExaminationDate
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName={
              CCUS_SPECIAL_MEDICAL_EXAMINATION
                .SPECIAL_MEDICAL_EXAMINATION_DATE_DENTAL.CCUS_NAME
            }
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
            safetyDocItem={true}
            info={
              !disabled &&
              '最新の⻭科特殊健診（歯牙酸蝕症健診）受診⽇を⼊⼒してください。'
            }
            warning={searchWarningMessage(
              formValues.special_medical_examination_date_dental,
              MEDICAL_EXAMINATION_PERIOD_KIND.SPECIAL_DEFAULT,
              messages.special_medical_examination_date_dental
            )}
          />
          {/* 受診病院 */}
          <GeneralTextInput
            labelName='受診病院'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='dental_hospital_name'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 所見の有無 */}
          <ObservationExistance
            formValues={formValues}
            disabled={disabled}
            targetName='dental_observation_flag'
            onChangeFn={onChangeFn}
          />
          {/* 管理区分 */}
          <GeneralTextInput
            labelName={'管理区分'}
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='dental_class'
            maxLength={20}
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 視力 */}
          <VisualAcuity
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            leftTargetName='dental_visual_acuity_left'
            rightTargetName='dental_visual_acuity_right'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 血圧 */}
          <BloodPressure
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            highTargetName='dental_high_bp'
            lowTargetName='dental_low_bp'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* X線所見 */}
          <GeneralTextInput
            labelName='X線所見'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='dental_x_ray_observation'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
          {/* 糖検査 */}
          <GeneralTextInput
            labelName='糖検査'
            formValues={formValues}
            messages={messages}
            disabled={disabled}
            targetName='dental_sugar_inspection'
            onChangeFn={onChangeFn}
            onBlurFn={onBlurFn}
          />
        </React.Fragment>
      )}
    </FormListItemGroup>
  );
};

const renderTooltipContent = data => {
  const rowStyle = {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return <div style={rowStyle}>{data}</div>;
};



// WEBPACK FOOTER //
// ./src/components/worker/form/MedicalExaminationForm.jsx